<template>
  <div id="topic-content">
    <!-- Loading 及 顯示圖表結果 -->
    <div class="loading" v-if="loading">
      <img src="../../assets/images/gif-loading.gif" alt="loading..."/>
    </div>
    <div v-else-if="initialized" id="charts">
		<div class="row row-cols-1 row-cols-lg-2">
			<ChartBlock
				v-for="(chart, index) in subcateg.charts"
				:key="chart.id"
				:index="index"
				:chart="chart"
				:columnsTitle="columnsTitle"
				:years="subcateg.years"
				:location="location"
				:temporalData="temporalData"
				:categ = "categ"
				:subcateg = "subcateg"
				:wmtslist = "wmtslist"
			/>
	  </div>
    </div>
  </div>

</template>

<script>
import ChartBlock from "./chart-block.vue"


export default {
  components: { ChartBlock },
  props: ["location", "categ", "subcateg"],
  mounted() {
	if (this.subcateg.geomtype != 'wmts'){
		this.getTemporaldata()
	};
	//////// view subcategs when mounted //////////
	//console.log(this.subcateg.charts)
  },
  created(){
  	this.$root.$on('refresh_grouplist', (group) => {
		this.subcateg.charts.filter((x)=>x.id==group.chartid)[0].group = group.grouplist;
		this.updateWMTSList();
    })
  },
  data() {
    return {
      initialized: false,
      loading: false,
      temporalData: {},
	  wmtslist:[]
    }
  },
  methods: {
    getTemporaldata() {
	  if (this.subcateg.minscl != 'county'){
		this.loading = true
		//console.log(this.subcateg.table_prefix);
		//console.log(this.subcateg.columns.map(x => x.id));
		//console.log(this.location.type);
		//console.log(this.location.id);
		this.axios.post("temporaldata", {
			dataset: this.subcateg.table_prefix,
			columns: this.subcateg.columns.map(x => x.id),
			adminscl: "_"+this.location.type,
			id: this.location.id,
		})
		.then((resp) => {
			//Need to load the temporal data according to the years
			//console.log(this.subcateg.charts)
			var admnlvcmp_arr = this.subcateg.charts.map(chart => chart.admnlvcmp)
			//console.log(resp.data);
			this.subcateg.years.forEach((yr,iyr)=>{
				this.temporalData[iyr]=resp.data.filter(x => x.year == yr)[0];
			});
			if (this.location.type != 'county'){
				//get county data
				this.axios.post("temporaldata", {
					dataset: this.subcateg.table_prefix,
					columns: this.subcateg.columns.map(x => x.id),
					adminscl: "_county",
					id: this.location.countyid,
				})
				.then((respcounty) => {
					//Again, need to load the temporal data according to the years
					this.subcateg.years.forEach((yr,iyr)=>{
						this.temporalData[iyr].county=respcounty.data.filter(x => x.year == yr)[0];
						//Take care of the end of multiple years by the service <categs12> (NOT categs12.json) instead of the number of sets of the return data.
						if (iyr == this.subcateg.years.length-1 && !admnlvcmp_arr.includes(true)){
							this.initialized = true;
							this.loading = false;
						}
					});
					if(admnlvcmp_arr.includes(true)){
						//get nation data
						this.axios.post("temporaldata", {
							dataset: this.subcateg.table_prefix,
							columns: this.subcateg.columns.map(x => x.id),
							adminscl: "_nation",
							id: 'TW',
						})
						.then((respnation) => {
							//Again, need to load the temporal data according to the years
							this.subcateg.years.forEach((yr,iyr)=>{
								this.temporalData[iyr].nation=respnation.data.filter(x => x.year == yr)[0];
								//Take care of the end of multiple years by the service <categs12> (NOT categs12.json) instead of the number of sets of the return data.
								if (iyr == this.subcateg.years.length-1){
									//console.log(this.temporalData)
									this.initialized = true;
									this.loading = false;
								}
							});
						})		
					};

				})
				.catch(function (error) {
					console.log(error);
				});
			}else{
				this.initialized = true;
				this.loading = false;
			}
		})
		.catch(function (error) {
			console.log(error);
		});
	  }else{
		this.loading = true
		this.axios.post("temporaldata", {
			dataset: this.subcateg.table_prefix,
			columns: this.subcateg.columns.map(x => x.id),
			adminscl: "_county",
			id: this.location.countyid,
		})
		.then((resp) => {
			//Need to load the temporal data according to the years
			this.subcateg.years.forEach((yr,iyr)=>{
				this.temporalData[iyr]=resp.data.filter(x => x.year == yr)[0];
				//Take care of the end of multiple years by the service <categs12> (NOT categs12.json) instead of the number of sets of the return data.
				if (iyr == this.subcateg.years.length-1){
					this.initialized = true;
					this.loading = false;
				}
			});
		})
		.catch(function (error) {
			console.log(error);
		});
	  }
    },
    updateWMTSList() {
		this.wmtslist = [];
		this.subcateg.charts.forEach((chart)=>{
			if (chart.group){
				this.wmtslist=this.wmtslist.concat(chart.group);
			}
		});
		this.showTile(this.wmtslist);
    },
    runSerial(tasks) {
      var result = Promise.resolve();
      tasks.forEach(task => {
        result = result.then(() => task());
      });
      return result;
    },
	showTile(grouplist){
		let tasks = [
			() => { $('#categ1').val(this.categ.id).change() },
			() => { $('#categ2').val(this.subcateg.id).change() },
			() => { if ($('#year').val()==0){$('#year').val(this.subcateg.years[this.subcateg.years.length-1]).change()} },
			() => { $("#wmtslist").val(JSON.stringify(grouplist)).change() }
			//() => { this.$root.$emit('retract_panel') }
		]
		this.runSerial(tasks)
	}
  },
  computed: {
    columnsTitle() {
      let dic = {}
      this.subcateg.columns.forEach((c) => {
        dic[c.id] = c.title
      })
      return dic
    },
  },
  watch: {
    subcateg() {
		if (this.subcateg.geomtype != 'wmts'){
			this.getTemporaldata()
		};
		////////  view subcategs when sub-category changed  //////////
		//console.log(this.subcateg.charts)
	},
    location() {
		if (this.subcateg.geomtype != 'wmts'){
			this.getTemporaldata()
		}
    }

  }
}
</script>
